"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableModificators = void 0;
const react_1 = require("react");
const tariffGroupMapper_1 = require("../../TariffsTable/tariffGroupMapper");
const useTableModificators = () => (0, react_1.useMemo)(() => ({
    row: (row) => {
        const { tariffGroup } = row.original;
        const tariffCode = (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariffGroup.id);
        return [
            tariffCode === 'business' ? 'blue-line' : undefined,
        ];
    },
    column: (column) => column.disableShowForDevice ? 'device-hidden' : undefined,
}), []);
exports.useTableModificators = useTableModificators;
//# sourceMappingURL=modificators.js.map